import { render, staticRenderFns } from "./HomeAccordionToTab.vue?vue&type=template&id=3e16e30a&scoped=true"
import script from "./HomeAccordionToTab.js?vue&type=script&lang=js&external"
export * from "./HomeAccordionToTab.js?vue&type=script&lang=js&external"
import style0 from "./HomeAccordionToTab.scss?vue&type=style&index=0&id=3e16e30a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16e30a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
